// Dummy valuers data used for the ValuationPanel page
const valuers = [
  {
    id: "VAL-001",
    profileImage: "",
    name: "John Doe",
    contacts: "+254700000001",
    internalRef: "INT-VAL-1001",
    createdBy: "admin@company.com",
    createdAt: "2025-10-10T09:32:00Z",
  },
  {
    id: "VAL-002",
    profileImage: "",
    name: "Jane Smith",
    contacts: "+254700000002",
    internalRef: "INT-VAL-1002",
    createdBy: "admin@company.com",
    createdAt: "2025-10-11T10:00:00Z",
  },
];

// Sample valuation configuration data for the ValuationConfig page
export const valuationConfigs = [
  {
    id: 'VC-001',
    name: 'Residential Property Rule',
    description: 'Default valuation rule for residential properties under 5 years old.',
    status: 'active',
    createdBy: 'admin@company.com',
    createdAt: '2025-09-01T08:00:00Z',
  },
  {
    id: 'VC-002',
    name: 'Vehicle Quick Estimate',
    description: 'Quick estimation rules for vehicles using model-year lookup.',
    status: 'pending',
    createdBy: 'ops@company.com',
    createdAt: '2025-09-10T11:20:00Z',
  },
];

export default valuers;
